// extracted by mini-css-extract-plugin
export default {"d3Histogram":"d3Histogram-IDzSj","axis":"axis-w6Fzn","axisLabel":"axisLabel-Xi5SL","bar":"bar-kM0s0","highlight":"highlight-zr5zN","hoverBar":"hoverBar-yrJzl"};